import { render, staticRenderFns } from "./CardKpi.vue?vue&type=template&id=763f899c&scoped=true"
import script from "./CardKpi.vue?vue&type=script&lang=js"
export * from "./CardKpi.vue?vue&type=script&lang=js"
import style0 from "./CardKpi.vue?vue&type=style&index=0&id=763f899c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "763f899c",
  null
  
)

export default component.exports